document.addEventListener("DOMContentLoaded", function () {
    const loadMore = document.getElementById('load-more-button');
    const productGrid = document.querySelector('.market-products__grid');
    const liveSearchInputs = document.querySelectorAll('[data-live-search]');
    const products = Array.from(document.querySelectorAll('.market-products__grid .product-card__ecom'));

    //loadMore
    loadMore?.addEventListener('click', function () {
        const button = this;
        const nextPage = parseInt(button.getAttribute('data-page')) + 1;
        const collectionUrl = window.location.pathname; 
       
    
        productGrid.classList.add('loading');
    
    
        fetch(`${collectionUrl}?page=${nextPage}`)
        .then((response) => response.text())
        .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
    
        // Get the product grid HTML from the fetched page
        const newProducts = doc.querySelector('.market-products__grid');
    
        if (newProducts && newProducts.innerHTML.trim() !== '') {
            // Append the new products to the existing grid
            productGrid.insertAdjacentHTML('beforeend', newProducts.innerHTML);
    
            // Check for pagination to see if there’s a next page
            const nextPagination = doc.querySelector('.market-products__pagination .next');
            if (nextPagination) {
            // Update the button's page attribute for the next fetch
            button.setAttribute('data-page', nextPage);
            } else {
            button.style.display = 'none';
            }
        } else {
            button.style.display = 'none';
        }
        })
        .catch((error) => {
        console.error('Error fetching products:', error);
        })
        .finally(() => {
        // Remove loading class from product grid
        productGrid.classList.remove('loading');
        });
    });

    //Search
    function debounce(func, wait) {
        let timeout;
        return function() {
          const context = this, args = arguments;
          clearTimeout(timeout);
          timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }

    liveSearchInputs.forEach(liveSearchInput => {
        function handleSearch() {
        const input = liveSearchInput.value.toLowerCase().trim();
        productGrid.classList.add('loading');
        loadMore ? loadMore.style.display = 'none' : false;

        if (input.length === 0) {
            fetch(`/collections/${window.location.pathname.split('/').pop()}`)
                .then(response => response.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, "text/html");
                    const newContent = doc.querySelector('.market-products__grid');
            
                    productGrid.innerHTML = newContent ? newContent.innerHTML : '<p>Geen producten gevonden.</p>';
                    productGrid.classList.remove('loading');
                })
                .catch(error => {
                    console.error('Fout bij het ophalen van de originele collectie:', error);
                    productGrid.innerHTML = '<p>Fout bij het laden van de originele collectie.</p>';
                    
                });
                productGrid.classList.remove('loading');
                window.newMarketAjax();
                loadMore ? loadMore.style.display = 'block' : false;
                return;
        }

        fetch(`/search?q=${encodeURIComponent(input)}&collection_id=${window.location.pathname.split('/').pop()}`)
        .then(response => response.text())
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newContent = doc.querySelector('.market-products__grid');
            
            if (newContent) {
                const currentCollectionHandle = window.location.pathname.split('/').pop();
                const productCards = newContent.querySelectorAll('.product-card__ecom');

                productCards.forEach(card => {
                    const collectionHandles = card.dataset.coll.split(',');
                    if (!collectionHandles.includes(currentCollectionHandle)) {
                        card.remove(); // Remove the card if it does not belong to the current collection
                    }
                    if (!newContent.querySelector('.product-card__ecom')){
                        newContent.innerHTML = '<p>Geen producten gevonden.</p>';
                    }
                });

                productGrid.innerHTML = newContent.innerHTML; // Update the grid with only the filtered products
            } else {
                productGrid.innerHTML = '<p>Geen producten gevonden.</p>';
            }
            
            productGrid.classList.remove('loading');
            window.newMarketAjax()
        })
        .catch(error => {
            console.error('Fout bij het ophalen van producten:', error);
            productGrid.innerHTML = '<p>Fout bij het laden van producten.</p>';
            productGrid.classList.remove('loading');
        });
    }
    
    const debouncedSearch = debounce(handleSearch, 500);
    liveSearchInput.addEventListener('input', debouncedSearch);
    });



        // liveSearchInput.addEventListener('input', function () {
        //     const query = this.value.toLowerCase().trim();
        //     productGrid.classList.add('loading');
    
        //     setTimeout(() => {
        //         let visibleProducts = 0;
        //         if (query.length === 0) {
                
        //             products.forEach((product) => {
        //                 product.style.display = 'flex';
        //             });
        //             visibleProducts = products.length; // All products are visible
        //         } else {
                
        //             products.forEach((product) => {
        //                 const title = product.dataset.title;
        //                 if (title.includes(query)) {
        //                     product.style.display = 'flex';
        //                     visibleProducts++;
        //                 } else {
        //                     product.style.display = 'none';
        //                 }
        //             });
        //         }
        //         if (visibleProducts === 0) {
        //             productGrid.style.display = 'none';
        //             loadMore?loadMore.style.display = 'none':false;
        //         } else {
        //             productGrid.style.display = 'grid';
        //             loadMore?loadMore.style.display="flex":false;
        //         }
        //         productGrid.classList.remove('loading');
        //     }, 200); 
        // });
    
    



    //filters
    function addHoverCards() {
        let marketProductsCards = document.querySelectorAll(".m-product_card");
      
        marketProductsCards.forEach((el) => {
          let img = el.querySelector("img");
      
          el.addEventListener("mouseenter", () => {
            gsap.to(img, {
              scale: 1.025,
              duration: 0.25,
              ease: "power1.out",
            });
          });
      
          el.addEventListener("mouseleave", () => {
            gsap.to(img, {
              scale: 1,
              duration: 0.25,
              ease: "power1.inOut",
            });
          });
        });
      }
      
    addHoverCards();
    // Toggle filter section visibility
    document.querySelector('[data-filter-open]').addEventListener('click', function () {
        const filterForm = document.querySelector('.market_filter-form');
        this.classList.toggle('active');
        filterForm.classList.toggle('active');
    });
    
    const dropdownTriggers = document.querySelectorAll('.filter_acc-trigger');

    dropdownTriggers.forEach((trigger) => {
        trigger.addEventListener('click', function () {
            const targetId = this.dataset.target; // Get the ID of the associated content
            const targetContent = document.getElementById(targetId); // Find the content by ID
        
            // Close any open dropdowns
            document.querySelectorAll('.filter_content').forEach((content) => {
                if (content !== targetContent) {
                    content.style.display = 'none'; // Hide other dropdowns
                    content.classList.remove('active'); // Remove active class
                }
            });
            dropdownTriggers.forEach((trigger) => {
                trigger.classList.remove('active')
            });
        
            // Toggle the current dropdown
            if (targetContent.style.display === 'none' || !targetContent.style.display) {
                targetContent.style.display = 'flex'; // Show the target content
                targetContent.classList.add('active'); // Add active class
                trigger.classList.add('active')
            } else {
                targetContent.style.display = 'none'; // Hide the target content
                targetContent.classList.remove('active'); // Remove active class
                trigger.classList.remove('active')
            }
        });
    });
    
    document
    .getElementById("filterForm")
    .addEventListener("input", function (event) {
        document.querySelector(".market_products-grid").classList.add('loading');
        document.querySelector(".market_products-grid").style.pointerEvents =
        "none";

        let filterForm = document.getElementById("filterForm");
        let formData = new FormData(filterForm);
        let query = new URLSearchParams(formData).toString();

        let currentUrl = window.location.href.split("?")[0];
        let newUrl = `${currentUrl}?${query}`;

        fetch(newUrl)
        .then((response) => response.text())
        .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            // const newFilterTop = doc.querySelector(".filter_top");
            // const currentFilterTop = document.querySelector(".filter_top");
            // if (newFilterTop && currentFilterTop) {
            // currentFilterTop.innerHTML = newFilterTop.innerHTML;
            // }

            const newProducts = doc.querySelector(".market-products__container");

            const currentProducts = document.querySelector(".market-products__container");
            if (newProducts && currentProducts) {
            currentProducts.innerHTML = newProducts.innerHTML;
            }

            disableFilters();
            history.replaceState(null, "", newUrl);
            addHoverCards();
            newMarketAjax();
            

            document.querySelector(".market_products-grid").classList.remove('loading');
            document.querySelector(".market_products-grid").style.pointerEvents =
            "auto";
        })
        .catch((error) => {
            console.error("Error fetching filtered products:", error);
        });
    });

    function disableFilters() {
        document.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
            if (input.disabled) {
            let formDisabledDiv = input
                .closest(".form_checkbox")
                .querySelector(".form_disabled");

            if (formDisabledDiv) {
                formDisabledDiv.style.display = "block";
            }
            }
        });
    }

    const layoutButtons = document.querySelectorAll("div.layout-button");

    layoutButtons.forEach((layoutButton) => {
    layoutButton.addEventListener("click", () => {
        // Check if the clicked button already has the 'is--active' class
        if (layoutButton.classList.contains("is--active")) {
        return; // Exit early, do not execute further actions
        }

        // Toggle the 'is--active' class on the clicked button
        layoutButton.classList.toggle("is--active");

        // Toggle the 'is--grid' class on the 'market_products-grid' element
        document
        .querySelector(".market_products-grid")
        .classList.toggle("is--grid");

        // Remove the 'is--active' class from all other buttons
        layoutButtons.forEach((button) => {
        if (button !== layoutButton) {
            button.classList.remove("is--active");
        }
        });
    });
    });
    
});
  